import(/* webpackMode: "eager" */ "/var/www/stms/FrontEnd/src/app/welcome/pricing/page.tsx");
